var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as LocalStorageUtil from './LocalStorageUtil';
import { publisherSuccess } from '../store/publisher/actions';
import moment from 'moment';
import _ from 'lodash';
import { toast } from 'react-toastify';
import * as Constant from "./Constant";
var COST = "COST";
var NUMBER = "NUMBER";
var PERCENTAGE = "PERCENTAGE";
var DATE_TIME = "DATE_TIME";
var TEXT = "TEXT";
export var formatPercentage = function (amount, numberOfDecimals, isNotDecimal) {
    if (numberOfDecimals === void 0) { numberOfDecimals = 2; }
    return parseFloat(amount).toFixed(numberOfDecimals) + '%';
};
export var formatCurrency = function (amount, numberOfDecimals, isNotDecimal) {
    if (numberOfDecimals === void 0) { numberOfDecimals = 2; }
    if (isNotDecimal) {
        var dataNumber = "" + amount;
        return '￥' + dataNumber.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    return '￥' + amount.toFixed(numberOfDecimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
export var formatNumber = function (num, numberOfDecimals, isNotDecimal) {
    if (numberOfDecimals === void 0) { numberOfDecimals = 0; }
    if (isNotDecimal) {
        var dataNumber = "" + num;
        return dataNumber.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    else {
        if (num === 0) {
            return '0';
        }
        else {
            return num.toFixed(numberOfDecimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
    }
};
export var getCurrentUser = function () {
    var currentUser = LocalStorageUtil.getItem(LocalStorageUtil.USER_DATA);
    return currentUser ? JSON.parse(currentUser) : null;
};
export var checkEmptyObjectData = function (data, chilrendName, attribute, isCheckArr, arrIndex) {
    if (data && data[chilrendName]) {
        if (isCheckArr) {
            if (data[chilrendName][arrIndex ? arrIndex : 0]) {
                if (attribute) {
                    if (data[chilrendName][arrIndex ? arrIndex : 0][attribute]) {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
        }
        else {
            if (attribute) {
                if (data[chilrendName][attribute]) {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
    return true;
};
export var checkEmptyArrData = function (data, index, attribute) {
    if (data && data[index]) {
        if (attribute) {
            if (data[index][attribute]) {
                return false;
            }
        }
        else {
            return false;
        }
    }
    return true;
};
export var getRoleUser = function () {
    var currentUser = getCurrentUser();
    if (currentUser && currentUser.roles) {
        return currentUser.roles;
    }
    return null;
};
export var checkInternalUser = function () {
    var currentUser = getCurrentUser();
    if (currentUser && currentUser.type == "INTERNAL") {
        return true;
    }
    return false;
};
export var checkRoleUser = function (role) {
    var currentUser = getCurrentUser();
    if (currentUser && currentUser.roles) {
        var foundRole = (currentUser.roles || []).find(function (roleUser) {
            return roleUser.name === role;
        });
        return foundRole ? true : false;
    }
    return false;
};
export var getCurrentUserDetails = function () {
    var userInfo = LocalStorageUtil.getItem(LocalStorageUtil.USER_INFO_KEY);
    return userInfo ? JSON.parse(userInfo) : null;
};
export var storeCurrentUserDetails = function (userInfo) {
    if (userInfo) {
        LocalStorageUtil.storeItem(LocalStorageUtil.USER_INFO_KEY, JSON.stringify(userInfo));
    }
};
export var getPublishersByCurrentUser = function () {
    var publisherList = LocalStorageUtil.getItem(LocalStorageUtil.PUBLISHERS_KEY);
    if (publisherList) {
        var publishers = JSON.parse(publisherList);
        return publishers;
    }
    return null;
};
export var getPublisherSelectedByCurrentUser = function () {
    var publishers = getPublishersByCurrentUser();
    var publisher = publishers ? publishers.find(function (publisher) { return publisher.selected; }) : null;
    return publisher;
};
export var storePublisherSelectedByCurrentUser = function (storePublishers) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var publisherList, publishers;
        return __generator(this, function (_a) {
            publisherList = LocalStorageUtil.getItem(LocalStorageUtil.PUBLISHERS_KEY);
            if (publisherList) {
                publishers = JSON.parse(publisherList);
                publishers = publishers.map(function (publisherUser) {
                    var findUser = storePublishers.find(function (storePublisher) { return storePublisher && storePublisher.id == publisherUser.id; });
                    publisherUser.selected = findUser ? true : false;
                    return publisherUser;
                });
                LocalStorageUtil.storeItem(LocalStorageUtil.PUBLISHERS_KEY, JSON.stringify(publishers));
                dispatch(publisherSuccess(publishers));
            }
            return [2 /*return*/, null];
        });
    }); };
};
export var getSelectedPublisherByUser = function () {
    var userInfoString = LocalStorageUtil.getItem(LocalStorageUtil.USER_INFO_KEY);
    if (userInfoString) {
        var userInfo = JSON.parse(userInfoString);
        if (userInfo && userInfo.publishers) {
            if (userInfo.publishers.length === 1) {
                return userInfo.publishers[0];
            }
            else {
                var selectedPublisher = userInfo.publishers.find(function (publisher) { return publisher.selected; });
                return selectedPublisher;
            }
        }
    }
};
export var checkRolePermissionUser = function (role, permission) {
    var currentUser = getCurrentUser();
    if (currentUser && currentUser.roles) {
        var foundRole = (currentUser.roles || []).find(function (roleUser) { return roleUser.name === role; });
        if (foundRole && foundRole.permissions) {
            var foundPermission = (foundRole.permissions || []).find(function (rolePermission) { return rolePermission.name == permission; });
            return foundPermission ? true : false;
        }
    }
    return false;
};
export var checkPermissionUser = function (permission) {
    var currentUser = getCurrentUser();
    if (currentUser && currentUser.roles) {
        var foundRole = (currentUser.roles || []).find(function (role) {
            var foundPermission = (role.permissions || []).find(function (rolePermission) { return rolePermission.name == permission; });
            return foundPermission ? true : false;
        });
        return foundRole ? true : false;
    }
    return false;
};
export var getUserType = function () {
    var currentUser = getCurrentUser();
    return currentUser.type;
};
export var sortList = function (list, sortField, orderBy, childrent) {
    var sortedList = (list || []).sort(function (a, b) {
        var keyA = a[sortField] ? a[sortField] : "";
        var keyB = b[sortField] ? b[sortField] : "";
        if (childrent) {
            keyA = keyA[childrent];
            keyB = keyB[childrent];
        }
        if (keyA < keyB)
            return orderBy === 'desc' ? 1 : -1;
        if (keyA > keyB)
            return orderBy === 'desc' ? -1 : 1;
        return 0;
    });
    return sortedList;
};
export var sortMultiColumn = function (list, sorts, children) {
    if (sorts) {
        var sortField = [];
        var sortOrderBy = [];
        _.forEach(sorts, function (value, key) {
            if (value) {
                sortField.push(children ? key + "." + children : key);
                sortOrderBy.push(value);
            }
        });
        list = _.orderBy(list, sortField, sortOrderBy);
    }
    return list;
};
export var loadLastReportSettingFromCache = function () {
    var cachedLastSettingJson = LocalStorageUtil.getItem(LocalStorageUtil.LAST_REPORT_SETTING);
    if (cachedLastSettingJson) {
        var cachedLastSetting = JSON.parse(cachedLastSettingJson);
        if (cachedLastSetting) {
            return cachedLastSetting;
        }
    }
};
export var formatValueByMetric = function (value, category, dataType, decimalPrecision, isNotDecimal) {
    if (value === null || value === undefined) {
        return '';
    }
    if (isNaN(value)) {
        return value;
    }
    var formattedValue = "";
    if (category === COST && dataType === NUMBER) {
        var val = Number(value);
        formattedValue = formatCurrency(val, decimalPrecision, isNotDecimal);
    }
    else if (dataType === PERCENTAGE) {
        var val = Number(value);
        formattedValue = formatPercentage(val, decimalPrecision, isNotDecimal);
    }
    else if (dataType === DATE_TIME) {
        var reportSetting = loadLastReportSettingFromCache();
        if (reportSetting && reportSetting.timeSegment === 'MONTHLY') {
            formattedValue = moment(value).format('YYYY/MM');
        }
        else {
            formattedValue = moment(value).format('YYYY/MM/DD');
        }
    }
    else if (dataType === TEXT) {
        formattedValue = value;
    }
    else {
        formattedValue = formatNumber(Number(value), 0, isNotDecimal);
    }
    return formattedValue;
};
export var getDateFormat = function (date) {
    var dd = "" + date.getDate();
    var mm = "" + (date.getMonth() + 1);
    var yyyy = date.getFullYear();
    return "" + yyyy + (mm.length > 1 ? mm : "0" + mm) + (dd.length > 1 ? dd : "0" + dd);
};
var objectByString = function (o, s) {
    s = '' + s;
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, ''); // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (null != o && k in o) {
            o = o[k];
        }
        else {
            return;
        }
    }
    return o;
};
export var sortArrayOfObjects = function (array, prop, reverse) {
    if (!array || !array)
        return;
    array.sort(function (a, b) {
        var aVal = objectByString(a, prop) || null;
        var bVal = objectByString(b, prop) || null;
        var _reverse = (true === reverse) ? -1 : 1;
        if (!isNaN(aVal) || !isNaN(bVal)) {
            return _reverse * (aVal - bVal);
        }
        else {
            if (null == aVal)
                aVal = '';
            if (null == bVal)
                bVal = '';
            return _reverse * aVal.localeCompare(bVal);
        }
    });
};
export var buildSettingForWidget = function (widgetDataTmp, dataTmp) {
    var settingWidget = dataTmp ? _.cloneDeep(dataTmp) : null;
    if (settingWidget && settingWidget.setting && widgetDataTmp && widgetDataTmp.defaultSetting) {
        Object.keys(settingWidget.setting).forEach(function (settingKey) {
            if (settingWidget.setting[settingKey] && widgetDataTmp.defaultSetting[settingKey]) {
                var type = settingWidget.setting[settingKey][Constant.WIDGET_SETTING_TYPE];
                if ((type == Constant.COMPONENT_TYPE_SELECT || type == Constant.COMPONENT_TYPE_DROPDOWN || type == Constant.COMPONENT_TYPE_BOX) && widgetDataTmp.defaultSetting[settingKey][Constant.WIDGET_SETTING_VALUES]) {
                    settingWidget.setting[settingKey][Constant.WIDGET_SETTING_VALUES] = widgetDataTmp.defaultSetting[settingKey][Constant.WIDGET_SETTING_VALUES];
                }
            }
        });
    }
    return settingWidget;
};
export var isSameDay = function (d1, d2) {
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);
    return d1.getTime() === d2.getTime();
};
export var notificationSimple = function (message, level, position) {
    var positionNotification = position ? position : "top-right";
    var configDefault = {
        position: positionNotification,
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    };
    switch (level) {
        case Constant.NOTIFICATION_SUCCESS:
            return toast.success(message, configDefault);
        case Constant.NOTIFICATION_WARN:
            return toast.warn(message, configDefault);
        case Constant.NOTIFICATION_INFO:
            return toast.info(message, configDefault);
        case Constant.NOTIFICATION_ERROR:
            return toast.error(message, configDefault);
        case Constant.NOTIFICATION_DARK:
            return toast.dark(message, configDefault);
        default:
            return toast(message, configDefault);
    }
};
export var getCachedMultiplePublishers = function () {
    var selectedPublishersJson = LocalStorageUtil.getItem(LocalStorageUtil.SELECTED_PUBLISHERS_REPORT_KEY);
    return selectedPublishersJson ? JSON.parse(selectedPublishersJson) : null;
};
export var checkNumber = function (num) {
    if (typeof num == 'number') {
        return true;
    }
    return false;
};
export var removeForbiddenCharacters = function (inputString) {
    var forbiddenChars = ['=', '.', ',', '-'];
    for (var _i = 0, forbiddenChars_1 = forbiddenChars; _i < forbiddenChars_1.length; _i++) {
        var char = forbiddenChars_1[_i];
        inputString = inputString.split(char).join('');
    }
    return inputString;
};
export var replaceAllCharacter = function (source, stringToFind, stringToReplace) {
    var temp = source;
    var index = temp.indexOf(stringToFind);
    while (index != -1) {
        temp = temp.replace(stringToFind, stringToReplace);
        index = temp.indexOf(stringToFind);
    }
    return temp;
};
